<template>
  <Dialog
      :header="modalTitle"
      v-model:visible="showModal"
      modal
      :style="{ width: modalWidth }"
      @hide="hideModal">
    <div>
      <a v-if="informationButton" class="form-select p-button p-1 text-center" style="max-width: 100px;background: rgb(14, 165, 233);color: white;" :href="informationButtonLink"  target="_blank">{{informationButton}}</a>
    </div>
    <form @submit.prevent="submitForm">
      <div v-for="(field, index) in formFields" :key="index" class="form-group d-flex"
           :class="{'flex-column justify-content-center': field.type !== 'switch', 'flex-row': field.type === 'switch'}">
        <div class="d-flex gap-2 align-items-center mt-2">
          <label v-if="!(formData.isGeneral && (field.model === 'gender' || field.model === 'ascendantSignId'))" :for="field.model">{{ field.label }}<span v-if="field.required">*</span></label>
          <ToolsPopover v-if="field.popoverText" :text="field.popoverText"/>
        </div>
        <!-- Text input -->
        <input v-if="field.type === 'text'"
               :id="field.model"
               :placeholder="field.placeholder"
               v-model="formData[field.model]"
               type="text"
               class="form-control w-100" />
        <textarea v-if="field.type === 'textarea'"
               :id="field.model"
               :placeholder="field.placeholder"
               v-model="formData[field.model]"
               type="text"
               class="form-control w-100" />

        <!-- Number input -->
        <input v-else-if="field.type === 'number'"
               :id="field.model"
               :placeholder="field.placeholder"
               v-model="formData[field.model]"
               type="number"
               class="form-control w-100"
               :value="field.model === 'inAppMessageTypeId' && !formData[field.model] ? 1 : formData[field.model]"
        />


        <!-- Date input -->
        <input v-else-if="field.type === 'date'"
               :id="field.model"
               :placeholder="field.placeholder"
               v-model="formData[field.model]"
               type="date"
               class="form-control w-100" />

        <!-- Select input -->
        <select v-else-if="field.type === 'select' && !(formData.isGeneral && (field.model === 'gender' || field.model === 'ascendantSignId'))"
                :id="field.model"
                v-model="formData[field.model]"
                class="form-control w-100">
          <option value="" disabled>Select an option</option>
          <option v-for="option in field.options" :key="option[field.id]" :value="option[field.id]">
            {{ option[field.value] }}
          </option>
        </select>



        <Dropdown v-else-if="field.type === 'drop'"
                  v-model="formData[field.model]"
                  :options="field.options"
                  :optionLabel="field.value"
                  :optionValue="field.id"
                  class="w-100"
        />


        <MultiSelect v-else-if="field.type === 'multi'"
                     class="w-100"
                     :options="field.options"
                     v-model="formData[field.model]"
                     :optionLabel="field.value"
                     :optionValue="field.id"
                     multiple />

        <div  v-else-if="field.type === 'relationship'" class="col-md-6 form-group position-relative" style="width: 100%">
          <MultiSelect  :options="[{ 'id': 0, 'value': 'All' }, { 'id': 1, 'value': 'Single' },
            { 'id': 2, 'value': 'Married' }, { 'id': 3, 'value': 'Divorced' },
            { 'id': 4, 'value': 'Engaged' }, { 'id': 5, 'value': 'In Relationship' },
            { 'id': 6, 'value': 'Complicated' },
            { 'id': 7, 'value': 'Widowed' },
            { 'id': 8, 'value': 'Open Relationship' }]"
                        v-model="formData[field.model]" optionLabel="value" optionValue="id" class="w-100"/>

        </div>
        <div  v-else-if="field.type === 'occupation'" class="col-md-6 form-group position-relative" style="width: 100%">
          <MultiSelect v-model="formData[field.model]" :options="occupations" optionLabel="name"
                       optionValue="id" placeholder="Select Occupations" class="w-100"/>

        </div>


        <AutoComplete
            v-else-if="field.type === 'places'"
            v-model="selectedPlace"
            :suggestions="places"
            @complete="searchPlaces"
            field="display_name"
            placeholder="Search for a location"
            class="w-100"
        />

        <Dropdown v-else-if="false"
                  v-model="formData[field.model]"
                  :options="countries"
                  optionLabel="name" optionValue="id"
                  placeholder="Select a Country"
                  filter
                  @change="getCities"
                  class="w-100"
        />


        <Dropdown v-else-if="field.type === 'city'"
                  v-model="formData[field.model]"
                  :options="cities" optionLabel="name" optionValue="id"
                  placeholder="Select a City" @change="getDistricts" filter class="w-100"
        />


        <Dropdown v-else-if="field.type === 'state'"
                  v-model="formData[field.model]" :options="districts" optionLabel="name" optionValue="id"
                  placeholder="Select a District" filter class="w-100"/>


        <!-- Switch input -->
        <input v-else-if="field.type === 'switch'"
               :id="field.model"
               type="checkbox"
               v-model="formData[field.model]"
               class="form-switch ms-2" />

        <!-- Custom hour-minute input -->
        <div v-else-if="field.type === 'hour-minute'" class="hour-minute-input d-flex gap-3">
          <input type="number" v-model="formData[field.hour]" placeholder="Hour" class="form-control"/>
          :
          <input type="number" v-model="formData[field.minute]" placeholder="Minute" class="form-control"/>
        </div>

        <!-- Custom field types can be added here -->



        <div v-else-if="field.type === 'languageInfos'" class="form-group">
          <div class="d-flex gap-2 align-items-center">
            <MultiSelect
                class="w-100"
                :options="field.options"
                v-model="newLanguage.key"
                :optionLabel="field.value"
                :optionValue="field.id"
                multiple />

            <input v-model="newLanguage.isActive" type="checkbox" class="form-switch" /> Active
            <button type="button" class="btn btn-success" @click="addLanguage">+</button>
          </div>

          <div v-for="(langInfo, index) in languageInfos" :key="index" class="d-flex gap-2 mt-2 align-items-center">
            <span>{{ langInfo.key }} - {{ langInfo.isActive ? 'Active' : 'Inactive' }}</span>
            <button type="button" class="btn btn-danger" @click="removeLanguage(index)">-</button>
          </div>
        </div>

        <div v-else-if="field.type === 'properties'" class="form-group">
          <div class="d-flex gap-2 align-items-center">

            <select v-if="field.typeOption === 'select'"
                    :id="field.model"
                    v-model="inputValue[field.model]"
                    class="form-control w-100">
              <option v-for="option in field.options" :key="option[field.value]" :value="option[field.value]">
                {{ option[field.text] }}
              </option>
            </select>
            <input
                v-else
                :id="field.model"
                :placeholder="field.placeholder || 'Metin girin'"
                v-model="inputValue[field.model]"
                type="text"
                class="form-control w-100" />
            <button type="button" class="btn btn-success" @click="addToArray(inputValue[field.model],field.model, field.typeOption)">+</button>
          </div>

          <div v-for="(item, index) in arrayData[field.model]" :key="index" class="d-flex gap-2 mt-2 align-items-center">
            <span>{{ item }}</span>
            <button type="button" class="btn btn-danger" @click="removeFromArray(index,field.model)">Sil</button>
          </div>
        </div>



        <div v-else-if="field.type === 'chakraContents'" class="form-group">

          <div class="d-flex gap-2 flex-column">
            <label :for="field.model">Contents Type</label>
            <input
                :id="field.model"
                :placeholder="'Enter Contents Type'"
                v-model="newContent.type"
                type="text"
                class="form-control w-100" />

            <label :for="field.model">Contents Variant</label>
            <input
                :id="field.model"
                :placeholder="'Enter Contents Variant'"
                v-model="newContent.variant"
                type="number"
                class="form-control w-100" />

            <label :for="field.model">Contents Text</label>
            <input
                :id="field.model"
                :placeholder="'Enter Contents Text'"
                v-model="newContent.text"
                type="text"
                class="form-control w-100" />
            <label :for="field.model">Contents Language</label>
            <Dropdown
                class="w-100"
                :options="languages"
                v-model="newContent.language"
                optionLabel="name"
                optionValue="id"
                :placeholder="'Enter Contents Language'"
            />
            <label :for="field.model">Contents Image Path</label>
            <input
                :id="field.model"
                :placeholder="'Enter Contents Image Path'"
                v-model="newContent.imagePath"
                type="text"
                class="form-control w-100" />

            <button type="button" class="btn btn-success" @click="addChakraContent">+</button>
          </div>

          <div v-for="(langInfo, index) in chakraContents" :key="index" class="d-flex gap-2 mt-2 align-items-center">
            <span>{{ langInfo }}</span>
            <button type="button" class="btn btn-danger" @click="removeChakraContent(index)">-</button>
          </div>
        </div>


        <div v-else-if="field.type === 'objProperties'" class="form-group">

          <div class="d-flex gap-2 flex-column">
            <template v-for="(obj, index) in field.obj" :key="index">
              <div class="d-flex gap-2 align-items-center mt-2">
                <label :for="obj.model">{{ obj.label }}</label>
                <ToolsPopover v-if="obj.popoverText" :text="obj.popoverText"/>
              </div>
              <input v-if="obj.type === 'text'"
                     :id="obj.model"
                     :placeholder="obj.placeholder"
                     v-model="objPropertiesFormData[obj.model]"
                     type="text"
                     class="form-control w-100" />
              <textarea v-if="obj.type === 'textarea'"
                     :id="obj.model"
                     :placeholder="obj.placeholder"
                     v-model="objPropertiesFormData[obj.model]"
                     type="textarea"
                     class="form-control w-100" />
              <Dropdown v-else-if="obj.type === 'drop'"
                        v-model="objPropertiesFormData[obj.model]"
                        :options="obj.options"
                        :optionLabel="obj.value"
                        :optionValue="obj.id"
                        class="w-100"
              />
            </template>
            <button type="button" class="btn btn-success" @click="addObjProperties">+</button>
          </div>

          <div v-for="(langInfo, index) in objProperties" :key="index" class="d-flex gap-2 mt-2 align-items-center">
            <span>{{ langInfo }}</span>
            <button type="button" class="btn btn-danger" @click="removeObjProperties(index)">-</button>
          </div>
        </div>



      </div>

      <!-- Submit button -->
      <button type="submit" class="btn btn-primary">Save</button>
    </form>
  </Dialog>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    show: Boolean,
    modalTitle: String,
    informationButton: String,
    informationButtonLink: String,
    modalWidth: {
      type: String,
      default: '50%'
    },
    formFields: {
      type: Array,
      required: true
    },
    method: {
      type: String,
      default: 'post'
    }
  },
  data() {
    return {
      formData: {},
      countries: [],
      cities: [],
      districts: [],
      languages: [],
      newLanguage: {
        key: '',
        isActive: true
      },
      languageInfos: [],
      objPropertiesFormData: {},
      newContent: {
        id: null,
        type: '',
        variant: '',
        text: '',
        language: '',
        imagePath: ''
      },
      chakraContents: [],
      objProperties: [],
      inputValue: {},
      arrayData: {},
      selectedPlace: null,
      places: [],
      relationshipType: []
    };
  },
  watch: {
    formFields: {
      immediate: true,
      handler(fields) {
        fields.forEach(field => {
          if (field.type === 'hour-minute') {
            this.formData[field.hour] = 0;
            this.formData[field.minute] = 0;
          } else {
            this.formData[field.model] = field.type === 'switch' ? false : '';
          }
        });
      }
    },
    'formData.language': {
      handler(newLang) {
        if (newLang) {
          this.fetchRelationshipList(newLang).then(() => {
            this.$forceUpdate();
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    this.languages = this.supportedLanguages || [];
  },
  computed: {
    ...mapGetters(['supportedLanguages','occupations']),
    showModal: {
      get() {
        return this.show;
      },
      set() {
        this.hideModal();
      },
    },
  },
  methods: {
    async fetchRelationshipList(language) {
      try {
        const resp = await this.$appAxios.get(`/admin/rag/relationship/list?language=${language}`);
        const relationshipList = resp.data.response;

        this.formFields.forEach(field => {
          if (field.model === 'ragRelationShips') {
            field.options = relationshipList;
          }
        });
      } catch (error) {
        console.error("Liste alınırken hata oluştu:", error);
      }
    },
    hideModal() {
      this.$emit('hide');
    },
    async submitForm() {
      this.formData.languageInfos = this.languageInfos
      this.formData.chakraContents = this.chakraContents
      this.formData.staticStoryList = this.objProperties
      this.formData.translations = this.objProperties
      this.formData.properties = this.arrayData.properties
      this.formData.ragRelationShips = this.arrayData.ragRelationShips
      this.formData.placeOfBirth = this.selectedPlace
      this.$emit('saveEndpoint', this.formData)
    },
    searchPlaces(event) {
      const query = event.query;
      this.$appAxios
          .get(`/global/v3/location/${query}`)
          .then(response => {
            this.places = response.data.response.placeList.result.map(place => ({
              id: place.place_id,
              display_name: place.display_name,
              lat: place.lat,
              lon: place.lon,
              type: place.type
            }));
          })
          .catch(err => {
            console.error("Error fetching places:", err);
          });
    },
    getCities(event) {
      var countryId = event.value;
      this.$appAxios.get("global/cities/" + countryId)
          .then(resp => {
            this.cities = resp.data.response;
          })
          .catch(err => {
            console.log(err)
          });
    },
    getDistricts(event) {
      var cityId = event.value;
      this.$appAxios.get("global/districts/" + cityId)
          .then(resp => {
            this.districts = resp.data.response;
          })
          .catch(err => {
            console.log(err)
          });
    },
    addLanguage() {
      if (this.newLanguage.key.length > 0) {
        this.newLanguage.key.forEach((languageKey) => {
          const existingLanguage = this.languageInfos.find(lang => lang.key === languageKey);
          if (!existingLanguage) {
            this.languageInfos.push({
              key: languageKey,
              isActive: this.newLanguage.isActive
            });
          }
        });
        this.newLanguage.key = [];
        this.newLanguage.isActive = false;
      }
    },
    removeLanguage(index) {
      this.languageInfos.splice(index, 1);
    },
    addChakraContent() {
      this.chakraContents.push({...this.newContent});
      this.newContent = {id: null, type: '', variant: '', text: '', language: '', imagePath: ''};
    },
    addObjProperties() {
      this.objProperties.push({...this.objPropertiesFormData});
      this.objPropertiesFormData = {};
    },
    removeChakraContent(index) {
      this.chakraContents.splice(index, 1);
    },
    removeObjProperties(index) {
      this.objProperties.splice(index, 1);
    },
    addToArray(inputValue, model, typeOption) {
      if (!this.arrayData[model]) {
        this.arrayData[model] = [];
      }

      if (typeOption === 'select') {
        if (inputValue) {
          this.arrayData[model].push(inputValue);
          this.inputValue = {};
        } else {
          this.$emit('routerPush')
        }
      } else {
        if (inputValue && inputValue.trim()) {
          this.arrayData[model].push(inputValue.trim());
          this.inputValue = {};
        }
      }
    },
    removeFromArray(index, model) {
      this.arrayData[model].splice(index, 1);
    },
  }
};
</script>
